import * as React from "react";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
import { SignInLink } from "./signLinks";
import { ClinicOnboardView } from "./clinicOnboardView";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WelcomeProps {
  gotoSignIn: () => void;
  gotoSignUp: () => void;
  clinicName: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicWelcome = ({ ...props }: WelcomeProps) => {
  return (
    <ClinicOnboardView
      title={`Welcome to ${props.clinicName}`}
      footerContent={
        <>
          <ClinicActionButton onClick={props.gotoSignUp} label="Sign up" />
          <SignInLink goToSignIn={props.gotoSignIn} />
        </>
      }
    >
      <div style={{ textAlign: "center" }}>
        {`Please sign up to join ${props.clinicName}.`}
        <br />
        If you already have an account, please sign in.
      </div>
    </ClinicOnboardView>
  );
};
